export const NEW_ZEALAND = 'New Zealand';
export const AUSTRALIA = 'Australia';
